/**
 * Desktop — renders all open windows
 * Pencere yokken DesktopHero gosterilir (mockup v3 referans)
 */
import DesktopHero from '../DesktopHero/DesktopHero'
import OSWindow from './OSWindow'
import { useWindowManager } from './WindowManagerContext'

export default function Desktop() {
  const { windows } = useWindowManager()
  const visibleWindows = windows.filter(w => !w.minimized)

  return (
    <div style={{ flex: 1, position: 'relative', overflow: 'hidden', minHeight: 0 }}>
      {/* Hero — pencere yokken goster */}
      {visibleWindows.length === 0 && <DesktopHero />}

      {/* Open windows */}
      {windows.map(win => (
        <OSWindow key={win.id} win={win} />
      ))}
    </div>
  )
}
